import ja from './ja'
import us from './us'
import kr from './kr'
import cn from './cn'
import tw from './tw'

const messages = {
  ja,
  us,
  kr,
  'zh-cn': cn,
  'zh-tw': tw,
}

export default messages
